import React from 'react'

type Props = {
  className?: string
  fillColor?: string
  size?: number
}

// Stroke magnifying glass (the Feedback Inbox Sketch prototype's search glyph).
const Search = ({
  className,
  fillColor = 'currentColor',
  size = 16,
}: Props) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={fillColor}
    strokeWidth="2"
    strokeLinecap="round"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.3-4.3" />
  </svg>
)

export default Search
